export enum LinkedDataConnectors {
  AKOYA = 'Akoya',
  CARTA = 'Carta',
  PLAID = 'Plaid',
  YODLEE = 'Yodlee',
  COINBASE = 'Coinbase',
  OFX = 'OFX',
}

export enum LinkedDataConnectorStatus {
  SUCCESS = 1,
  WARNING = 2,
  ERROR = 3,
  LOGIN_REQUIRED = 4,
}
